import React, { useMemo, useState, useRef } from 'react'
import { Input, Button } from 'antd'

import styles from './index.less'

const MAP = {
    initial: {
        key: 'initial',
        text: '获取验证码',
    },
    sending: {
        key: 'sending',
        text: '发送中...',
    },
    resend: {
        key: 'resend',
        // eslint-disable-next-line no-template-curly-in-string
        text: '重新发送(${count})',
    },
    retry: {
        key: 'retry',
        text: '重新获取',
    },
}

export default ({ fetch, value, onChange, interval = 60, ...restProps }) => {
    const $this = useRef({
        timer: null,
    })
    const [status, setStatus] = useState(MAP.initial.key)
    const [count, setCount] = useState(interval)
    const [loading, setLoading] = useState(false)

    const start = async () => {
        setLoading(true)

        try {
            await fetch()

            setStatus(MAP.resend.key)

            if ($this.current.timer) {
                clearInterval($this.current.timer)
            }

            setCount(prev => prev - 1)

            $this.current.timer = setInterval(() => {
                setCount(prev => {
                    if (prev > 1) {
                        return prev - 1
                    } else {
                        clearInterval($this.current.timer)

                        setStatus(MAP.retry.key)

                        return interval
                    }
                })
            }, 1000)
        } catch (e) {
            console.error('catchError', e)
            setStatus(MAP.initial.key)
        }
        setLoading(false)
    }

    const btnProps = useMemo(() => {
        switch (status) {
            case MAP.initial.key:
                return {
                    children: MAP.initial.text,
                }
            case MAP.sending.key:
                return {
                    children: MAP.sending.text,
                    loading: true,
                }
            case MAP.resend.key:
                return {
                    children: MAP.resend.text.replace(/\${.+?}/, String(count)),
                    disabled: true,
                }
            case MAP.retry.key:
                return {
                    children: MAP.retry.text,
                }
            default:
                return null
        }
    }, [status, count])

    return (
        <div className={styles.container}>
            <Input
                allowClear={false}
                className={styles.lt}
                {...restProps}
                value={value}
                onChange={({ target: { value: mobile } }) => onChange(mobile)}
            />

            <Button className={styles.rt} loading={loading} {...btnProps} onClick={start} />
        </div>
    )
}
